var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemainingShipmentsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6364_4764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 51C39.5833 51 51 39.5833 51 25.5C51 11.4167 39.5833 0 25.5 0C11.4167 0 0 11.4167 0 25.5C0 39.5833 11.4167 51 25.5 51Z",
    fill: "#A3C9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 49C38.4787 49 49 38.4787 49 25.5C49 12.5213 38.4787 2 25.5 2C12.5213 2 2 12.5213 2 25.5C2 38.4787 12.5213 49 25.5 49Z",
    fill: "#C5EDFF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6364_4764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.5388 20.864H33.0183V16.2524C33.0183 16.1648 32.9473 16.0938 32.8597 16.0938H28.1297H23.3996C23.312 16.0938 23.241 16.1648 23.241 16.2524V20.864V25.7749H28.1297H33.0183H37.907V21.2323C37.9071 21.0289 37.7422 20.864 37.5388 20.864Z",
    fill: "#FFC06C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.907 25.7742H33.0183V20.8633H37.5387C37.7421 20.8633 37.907 21.0282 37.907 21.2316V25.7742Z",
    fill: "#EDA558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1298 20.8633H23.241V25.7742H28.1298V20.8633Z",
    fill: "#EDA558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0183 20.864H28.1296V16.0938H32.8597C32.9473 16.0938 33.0183 16.1648 33.0183 16.2524V20.864Z",
    fill: "#EDA558"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2467 15.1703V11.6203C16.2467 11.3165 16.0005 11.0703 15.6967 11.0703C15.3929 11.0703 15.1467 11.3165 15.1467 11.6203V15.1703H16.2467Z",
    fill: "#CCCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4695 20.6797H10.9238V26.0169H20.4695V20.6797Z",
    fill: "#06329D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9987 24.6867C38.9987 25.2061 38.5776 25.6273 38.058 25.6273H9.39779C9.14558 25.6273 8.95658 25.8591 9.00868 26.1059C9.29816 27.4761 10.0018 29.2912 11.6501 31.132C11.9602 31.4783 12.0297 31.9782 11.8294 32.3976L10.9414 34.2569C10.7923 34.5689 11.0198 34.9296 11.3656 34.9296H39.7175C39.8987 34.9296 40.0636 34.825 40.1407 34.6609L44.955 24.4124C45.1007 24.1024 44.8745 23.7461 44.5318 23.7461H39.9392C39.4198 23.7461 38.9987 24.1672 38.9987 24.6867Z",
    fill: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5318 23.7461H40.8313L35.5776 34.9297H39.7174C39.8986 34.9297 40.0635 34.825 40.1406 34.661L44.9549 24.4125C45.1007 24.1024 44.8744 23.7461 44.5318 23.7461Z",
    fill: "#EF2929"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8498 20.2102H12.5437V15.1081C12.5437 14.9599 12.6638 14.8398 12.8119 14.8398H18.5816C18.7297 14.8398 18.8498 14.9599 18.8498 15.1081V20.2102Z",
    fill: "#06329D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0122 21.3243H10.3813C10.2856 21.3243 10.208 21.2468 10.208 21.1511V19.8217C10.208 19.726 10.2856 19.6484 10.3813 19.6484H21.0122C21.1079 19.6484 21.1854 19.726 21.1854 19.8217V21.1511C21.1854 21.2468 21.1079 21.3243 21.0122 21.3243Z",
    fill: "#CCCBCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0121 19.6484H17.1089V21.3243H21.0121C21.1078 21.3243 21.1854 21.2468 21.1854 21.1511V19.8217C21.1854 19.726 21.1078 19.6484 21.0121 19.6484Z",
    fill: "#B9BBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9209 31.6797C11.9668 31.9176 11.9382 32.1693 11.8293 32.3974L10.9413 34.2566C10.7922 34.5687 11.0197 34.9294 11.3655 34.9294H39.7174C39.8986 34.9294 40.0635 34.8247 40.1406 34.6607L41.5409 31.6797H11.9209Z",
    fill: "#20C1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1043 31.6798L35.5776 34.9295H39.7174C39.74 34.9295 39.7624 34.9278 39.7844 34.9246C39.8284 34.9182 39.8708 34.9057 39.9106 34.8876C39.9503 34.8696 39.9874 34.8461 40.0205 34.8178C40.0704 34.7753 40.1116 34.7222 40.1405 34.6607L41.5408 31.6797L37.1043 31.6798Z",
    fill: "#0FB0C0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6364_4764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 51,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6364_4764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(9 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemainingShipmentsIcon);
export default __webpack_public_path__ + "static/media/remaining_shipments_icon.cb91968353e8814b8930c974d00faa46.svg";
export { ForwardRef as ReactComponent };